


























































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import moment from "moment";
import EventTimeline from "@/components/Lead/EventTimeline.vue";
import { firestore, collections } from "@/configs/firebase";
import logger from "@/configs/logger";
import { User } from "@/types";
import { objectify } from "@/helpers";
import { capitalize, throttle } from "lodash";
import logEvent, {
  VerificationStatusName,
  SaleStatusName,
  VerificationType,
  ProductGroup,
  ProductGroups,
  LeadEventTypes
} from "@/lib/logEvent";

@Component({ components: { EventTimeline } })
export default class Verification extends Vue {
  @Prop({ required: true }) lead!: any;
  @State("user") user!: User;

  ready: any = {};
  readyForTransferCheck = false;
  isRecording: any = {};
  recordingGroup: ProductGroup | null = null;

  get canViewDetails() {
    return (
      this.user.roles.includes("admin") ||
      this.lead.verification_agent_email === this.user.email
    );
  }

  get productGroups(): ProductGroup[] {
    // think of this as groups of products that are verified/sold together
    return [
      ProductGroups.NIIA_HEALTH,
      ProductGroups.INSURITA_ANCILLARY,
      ProductGroups.DISCOUNT_PLAN
    ];
  }

  get statusActions(): any[] {
    return this.productGroups.map(group => ({
      name: group,
      data: this.createStatusButtons(group, this.lead)
    }));
  }

  @Watch("lead")
  onLeadUpdate(val: any, prev: any) {
    if (!Object.is(val, prev)) {
      throttle(this.notifyOnLeadUpdate, 1000, { leading: false });
    }
  }

  created() {
    logger("log", "lead id", this.lead.id);
    this.readyForTransferCheck = this.lead.ver_ready_for_transfer;
  }

  async unclaim() {
    try {
      await collections.lead
        .doc(this.lead.id)
        .update({ verification_agent_email: null, agent_of_record: null });
    } catch (err) {
      logger("error", "unclaim lead eror:", err);
      this.$toasted.error("Uncalim lead error").goAway(2000);
    }
  }

  handleStartRecording(group: ProductGroup) {
    logger("log", "start recording");
    this.setVerStatus(group)("started", "voice", this.lead);
    this.isRecording[group] = true;
    this.recordingGroup = group;
    this.$forceUpdate();
  }

  handleStopRecording(group: ProductGroup) {
    logger("log", "stop recording");
    this.setVerStatus(group)("stopped", "voice", this.lead);
    this.isRecording[group] = false;
    this.recordingGroup = null;
    this.$forceUpdate();
  }

  notifyOnLeadUpdate() {
    this.$toasted.info("Lead details was update").goAway(2000);
  }

  getLeadName(lead: any): string {
    const firstName = lead.first_name || "Lead";
    const lastName = lead.last_name || "Name";
    return `${firstName} ${lastName}`;
  }

  async setReadyForTransfer(val: boolean) {
    try {
      await collections.lead
        .doc(this.lead.id)
        .update({ ver_ready_for_transfer: val });
      this.$toasted.success("You are now ready for transfer").goAway(2000);
    } catch (err) {
      logger("error", "ready for trasnfer error", err);
      this.$toasted.error("Ready for trasnfer error.").goAway(2000);
    }
  }

  setVerStatus(productGroup: ProductGroup): Function {
    return async (
      status: VerificationStatusName,
      verType: VerificationType,
      lead: any
    ) => {
      try {
        await logEvent.verificationStatus(lead.id, {
          event_type: "verification_status",
          name: status,
          verification_type: verType,
          group: productGroup,
          created_ts: firestore.Timestamp.now(),
          user_email: this.user.email
        });
        //this.$toasted.success("verification status updated").goAway(2000);
      } catch (err) {
        this.$toasted.error("this verification status failed").goAway(2000);
      }
    };
  }

  createStatusButtons(productGroup: ProductGroup, lead: any): any[] {
    const updateStatus = this.setVerStatus(productGroup);
    const buttons = [
      "text/sent",
      "text/received",
      "email/sent",
      "email/received"
      //"voice/started",
      //"voice/stopped"
    ];

    return buttons.map(button => {
      const status = button.split("/")[1] as VerificationStatusName;
      const esigOrVoice = button.split("/")[0];
      let verificationType: VerificationType;
      let buttonName = `${esigOrVoice} ${status}`;

      // TODO: remove esig prefix
      if (esigOrVoice == "text") {
        verificationType = "esig_text";
      } else if (esigOrVoice == "email") {
        verificationType = "esig_email";
      } else {
        verificationType = "voice";
      }

      if (status === "started") {
        buttonName = "Start Recording";
      } else if (status === "stopped") {
        buttonName = "End Recording";
      }

      return {
        type: productGroup,
        name: buttonName,
        key: `${productGroup}/${button}`,
        onClick: () => updateStatus(status, verificationType, lead)
      };
    });
  }
}
